import React from 'react';
import { Card } from 'react-bootstrap';
 
const SourceDoc = ({text, highlight_spans}) => {

  const sortSpans = (highlight_spans) => highlight_spans.sort((a, b) => a[0] - b[0]);

  const getHighlightedText = (text, spans) => {
    const sortedSpans = sortSpans(spans);
    let lastIndex = 0;
    const parts = [];

    sortedSpans.forEach(span => {
      const [start, end] = span;
      if (start > lastIndex) {
        parts.push({ text: text.slice(lastIndex, start), highlighted: false });
      }
      parts.push({ text: text.slice(start, end), highlighted: true });
      lastIndex = end;
    });

    if (lastIndex < text.length) {
      parts.push({ text: text.slice(lastIndex), highlighted: false });
    }

    return parts.map((part, index) => (
      <span
        key={index}
        style={{
          backgroundColor: part.highlighted ? '#ffff00' : 'transparent',
        }}
      >
        {part.text}
      </span>
    ));
  };

  return (
    <div className="mb-20 mt-50">
        <h2>Original Text</h2>
        <Card>
            <Card.Body>
                <Card.Text as="div">
                  {getHighlightedText(text, highlight_spans)}
                </Card.Text>
            </Card.Body>
        </Card>
    </div>
  );
};

export default SourceDoc;
